module.exports = __webpack_public_path__ + "img/delete-impact-post.30529621.svg";